<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Data Table Teman Treasury
      </b-card-header>
      <b-card-body>
        <teman-treasury></teman-treasury>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import TemanTreasury from './Table'

  export default {
    name: 'tt',
    components: {
      TemanTreasury
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
